export function postcodeValidation(postcode) {
  const postcodeRegex = /^[\w\d]{2,4} [\w\d]{3}$/g
  if (postcode.match(postcodeRegex)) {
    return postcode
  }
  postcode = postcode.replace(/\s/g, "")
  return postcode.slice(0, -3) + " " + postcode.slice(-3)
}
